import React, { Component } from 'react';
import { TransactionRequestType } from '../../../domain/stream/transaction/TransactionDomains';
import Icon from '../../../icons/Icon';
import { ServiceNames } from '../../../constant/ServiceNames';
import ServiceContainer from '../../../config/ServiceContainer';
import TransactionService from '../../../service/TransactionService';
import { SandboxHistorySchema } from '../../../../../server/src/lib/domain/stream/transaction/TransactionDomains';
import { RootState } from '../../../redux/store';
import { clearHistories, setHistories } from '../../../redux/actions/SandboxActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import LanguageUtil from '../../../util/LanguageUtil';
import moment from 'moment';

class SandboxHistoryItemComponent extends Component<Props> {
  private readonly transactionService: TransactionService = ServiceContainer.getInstance().get(ServiceNames.CHANNEL);

  render() {
    const { history } = this.props;
    return (
      <div className={'flex px-5 py-2 items-center justify-between w-full gap-x-3 text-md last:border-none border-b-[1px] border-[#EAECF0] '}>
        <div onClick={this.onClickHistory} className={`flex items-center cursor-pointer ${this.getRequestColor(history.requestType)}`}>
          {history.requestType}
        </div>
        <div className={'flex items-center text-[#2D3646] text-md truncate'}>{history.transactionName}</div>
        <div className={'flex items-center justify-end   cursor-pointer gap-x-1'}>
          <div onClick={this.onClickPin}>
            <Icon icon={'pin'} className={`${history.pinned ? 'text-[#458EF7]' : 'text-gray-500'}`} size={14} />
          </div>
          <div onClick={this.onClickDelete}>
            <Icon icon={'delete'} size={14} />
          </div>
        </div>
      </div>
    );
  }

  private onClickHistory = () => {
    const { history, setHistory } = this.props;
    setHistory(history);
  };

  private onClickPin = async () => {
    const {
      history,
      setHistories,
      sandbox: { historyDate },
    } = this.props;
    await this.transactionService.pinHistory(history.id);
    const histories = await this.transactionService.getHistory(historyDate as string);
    setHistories(histories);
  };

  private onClickDelete = async (e: any) => {
    const {
      history,
      setHistories,
      sandbox: { histories },
    } = this.props;
    customConfirm({
      target: e.currentTarget,
      accept: async () => {
        await this.transactionService.deleteHistory(history.id);
        if (history.pinned) {
          const updatedPinned = histories?.pinned?.filter((h) => h.id !== history.id) || [];
          setHistories({
            pinned: updatedPinned,
            histories: histories?.histories || {},
          });
        } else {
          const dateKey = moment(history.createdAt).format('DD-MM-YYYY');
          const updatedDateHistories = histories?.histories?.[dateKey]?.filter((h) => h.id !== history.id) || [];
          const updatedHistories = { ...histories?.histories };
          if (updatedDateHistories.length === 0) {
            delete updatedHistories[dateKey];
          } else {
            updatedHistories[dateKey] = updatedDateHistories;
          }
          setHistories({
            pinned: histories?.pinned || [],
            histories: updatedHistories,
          });
        }
      },
      message: LanguageUtil.get({ id: 'messages.confirm.delete1', defaultMessage: 'Are you sure you want to delete?' }),
    });
  };

  private getRequestColor(requestType: TransactionRequestType): string {
    switch (requestType) {
      case 'RESUBMIT':
        return 'text-[#50A67F]';
      case 'SUBMIT':
        return 'text-[#F0A042]';
      case 'STORE':
        return 'text-[#175CD3]';
      case 'UPDATE':
        return 'text-[#5925DC]';
      case 'DELETE':
        return 'text-[#D2332F]';
      default:
        return 'text-gray-500';
    }
  }
}

interface Props extends ReduxProps {
  history: SandboxHistorySchema;
  setHistory: (history: SandboxHistorySchema) => void;
}

const mapStateToProps = (state: RootState) => ({
  sandbox: state.sandbox,
});
const mapDispatchToProps = { setHistories, clearHistories };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SandboxHistoryItemComponent);
